<template>
  <svg :class="[`c-icon`, className]">
    <use v-bind="{ 'xlink:href': svgPath }" />
  </svg>
</template>

<script>
import { svgHash } from '@/main.js'

export default {
  name: 'Sprite',
  props: {
    src: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: null,
    },
  },
  computed: {
    svgPath () {
      return `/sprite.svg?cr=${svgHash}#sprite-${this.src}`
    },
  },
}
</script>

<style lang="scss">
.c-icon {
  fill: currentColor;
}
</style>
